/**
 * ============================================================
 * Belarusian
 * ============================================================
 *
 * Translators:
 *
 * Yakauleu "Wiedy Mi" Uladzislau <u.yakauleu@gmail.com>
 */

export default {
	'AdvanceHelp': 'Каб гуляць, націсніце на прабел або леваю кнопку мышы',
	'AllowPlayback': 'Націсніце тут, каб дазволіць прайграванне аўдыя',
	'Audio': 'Аўдыя',
	'AutoPlay': 'Аўта',
	'AutoPlayButton': 'Уключыць аўтапрайграванне',
	'AutoPlaySpeed': 'Хуткасць аўтапрайгравання',

	'Back': 'Назад',
	'BackButton': 'Перайсці назад',

	'Cancel': 'Скасаваць',
	'Close': 'Закрыць',
	'Confirm': 'Выйсці?',
	'Credits': 'Цітры',

	'Delete': 'Выдаліць',
	'DialogLogButton': 'Паказаць журнал дыялогаў',

	'FullScreen': 'Поўны экран',

	'Gallery': 'Галерэя',

	'Help': 'Дапамога',
	'Hide': 'Схаваць',
	'HideButton': 'Схаваць тэкставае поле',

	'iOSAudioWarning': 'Налады аўдыя не падтрымліваюцца на iOS',

	'KeyboardShortcuts': 'Хуткія клавішы',

	'Language': 'Мова',
	'Load': 'Загрузіць',
	'LoadAutoSaveSlots': 'Аўтазахаваныя гульні',
	'LoadButton': 'Адкрыць меню загрузкі',
	'Loading': 'Загрузка',
	'LoadingMessage': 'Пачакайце поўнай загрузкі рэсурсаў',
	'LoadSlots': 'Захаваныя гульні',
	'LocalStorageWarning': 'Лакальнае сховішча недаступна ў гэтым браўзеры',
	'Log': 'Журнал',

	'Music': 'Хучнасць музыкі',

	'NewContent': 'Даступна новае змесціва, перазагрузіце старонку, каб атрымаць апошнюю версію',
	'NoSavedGames': 'Няма захаваных гульняў',
	'NoAutoSavedGames': 'Няма аўтазахаваных гульняў',
	'NoDialogsAvailable': 'Няма даступных дыялогаў. Дыялогі будуць з\'яўляцца тут па меры праходжання гульні',

	'OK': 'ОК',
	'OrientationWarning': 'Каб гуляць, павярніце вашу прыладу',
	'Overwrite': 'Перазапісаць',

	'QuickButtons': 'Кнопкі хуткага меню',
	'QuickMenu': 'Хуткае меню',
	'Quit': 'Выйсці',
	'QuitButton': 'Выйсці з гульні',

	'Resolution': 'Разрознасць',

	'Save': 'Захаваць',
	'SaveButton': 'Адкрыць меню захавання',
	'SaveInSlot': 'Захаваць у слот',
	'SelectYourLanguage': 'Select your language',
	'Settings': 'Налады',
	'SettingsButton': 'Адкрыць меню налад',
	'Show': 'Паказаць',
	'Skip': 'Прапусціць',
	'SkipButton': 'Аўтапераход',
	'SlotDeletion': 'Вы ўпэўнены, што хочаце выдаліць гэты слот?',
	'SlotOverwrite': 'Вы ўпэўнены, што хочаце перазапісаць гэты слот?',
	'Sound': 'Гучнасць гукаў',
	'Start': 'Пачаць',
	'Stop': 'Спыніць',

	'TextSpeed': 'Хуткасць тэксту',

	'Video': 'Гучнасць відэа',
	'Voice': 'Гучнасць голасу',

	'Windowed': 'Аконны рэжым'
};